<template>
  <div>
    <!-- List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
      :moduleName="`iam.groups`"
      :moduleCreateEvent="`subHeaderDetailOpen`"
      :selectedItemId="selectedItemId"
      :openNewItem="openNewItem"
    >
      <template v-slot:item.action="{ item }">
        <ActionButton
          icon="fas fa-pencil"
          :title="$t('global.update')"
          @click.native="openSubRowDetail(item)"
        ></ActionButton>

        <DeleteButton
          icon="fad fa-trash"
          :title="$t('global.delete')"
          @click.native="openDeleteHandler(item)"
        ></DeleteButton>
      </template>

      <template v-slot:subRow="{ item, selectedItemId, openNewItem }">
        <div v-if="selectedItemId == item.dn" class="subRow">
          <!-- members -->
          <div>
            <Input
              label="global.description"
              v-model="item.description_update"
              :defaultValue="item.description"
            />
          </div>
          <!-- /detail -->

          <!-- buttons -->
          <div class="d-flex align-items-center justify-content-end mt-5">
            <b-button
              type="button"
              variant="primary"
              @click="saveDetail(item)"
              class="px-10 mr-2"
              >{{ $t('global.save') }}</b-button
            >
          </div>
          <!-- /buttons -->

          <!-- members -->
          <div>
            <b-form-group :label="$t('global.member')" class="mb-0">
            </b-form-group>

            <div v-for="(pl, index) in item.member" :key="index">
              <div class="d-flex mb-3">
                <div class="mr-3">
                  <b-form-input
                    :id="`${index}-pKey`"
                    v-model="item.member[index]"
                    :placeholder="$t('global.enterMemberInfo')"
                    :readonly="true"
                  ></b-form-input>
                </div>
                <div class="ml-auto">
                  <DeleteButton
                    icon="fad fa-trash"
                    :title="$t('global.delete')"
                    @click.native="removeMember(item.dn, item.member[index])"
                  ></DeleteButton>

                  <!-- <b-dropdown variant="success"
                              class="btn-icon more-dropdown"
                              right>
                    <template v-slot:button-content><i class="fas fa-cog p-0"></i></i>
                    </template>
                    <b-dropdown-item @click="addNewMemberItem(item.dn)">{{$t('global.addNew')}}</b-dropdown-item>
                    <b-dropdown-divider />
                    <b-dropdown-item @click="removeMemberItem(item.dn, index)"
                                     class="text-danger">{{$t('global.delete')}}</b-dropdown-item>
                  </b-dropdown> -->
                </div>
              </div>
            </div>

            <div
              v-if="openNewItem"
              class="d-flex align-items-center justify-content-between mt-5"
            >
              <multiselect
                v-model="item.newMember"
                :options="memberList"
                :allowEmpty="false"
                :show-labels="false"
                :searchable="true"
                :placeholder="$t('global.member')"
                track-by="dn"
                :custom-label="customMemberListLabel"
                :limit="3"
                :show-no-results="false"
                class="mr-5"
              />

              <b-button
                type="button"
                variant="primary"
                @click="addMember(item)"
                class="px-10"
                >{{ $t('global.save') }}</b-button
              >
            </div>
          </div>
          <!-- /members -->

          <!-- buttons -->
          <div class="d-flex align-items-center justify-content-end mt-5">
            <b-button
              type="button"
              variant="info"
              @click="addNewMemberItem(item.dn)"
              class="px-10 mr-2"
              >{{ $t('global.addMember') }}</b-button
            >

            <b-button
              type="button"
              variant="danger"
              @click="closeSubRowDetail()"
              class="px-10"
              >{{ $t('global.close') }}</b-button
            >
          </div>
          <!-- /buttons -->
        </div>
      </template>
    </List>
    <DeleteOperation :url="deleteOperationUrl" @updateList="getList" />

    <!-- Create Popup -->
    <DetailModal
      :title="$t(selectedItem == '' ? 'iam.createNewGroup' : 'iam.updateGroup')"
      :show="showDetail"
      @closeDetail="closeDetail()"
      @confirm="confirmModal()"
      :resetForm="resetForm"
    >
      <GroupForm
        :confirmModal="confirmCreate"
        @resetDetailForm="resetDetailForm"
        :selectedItem="selectedItem"
      />
    </DetailModal>
  </div>
</template>

<script>
// Utils
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'
import EventBus from '@/event-bus'

// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'GroupList',
  props: {
    detailData: Array | String,
  },
  data() {
    return {
      showDetail: false,
      loading: false,
      confirmCreate: false,
      resetForm: false,
      header: [
        {
          text: 'global.groupName',
          value: 'cn',
        },
        {
          text: 'global.description',
          value: 'description',
        },
        { text: 'global.actions', value: 'action', size: '120px' },
      ],
      data: [],
      pagination: {},
      meta: {},
      deleteOperationUrl: '',
      selectedItem: '',
      closeSecondModal: false,
      selectedItemId: '',
      memberList: [],
      newMember: '',
      openNewItem: false,
    }
  },
  created() {
    this.setCustomHeaderParams()
    this.getList()
    this.getMemberList()

    EventBus.$on(`subHeaderDetailOpen`, this.listener)
  },
  beforeDestroy() {
    EventBus.$off(`subHeaderDetailOpen`, this.listener)
  },
  methods: {
    listener(payload) {
      this.selectedItem = ''
      this.showDetail = payload
    },
    setCustomHeaderParams() {
      this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
        menuList: [
          {
            title: 'global.services',
          },
          {
            title: 'iam.plusCloudsIAM',
            route: '/services/iam',
          },
          {
            title: this.detailData
              ? this.detailData.name
              : this.$t('global.detail'),
            notML: false,
          },
        ],
        showSearch: false,
        detailPlaceholder: 'iam.createNewGroup',
      })
    },
    getMemberList() {
      this.getMembers()
        .then((res) => {
          this.memberList = res.data
        })
        .catch(() => {
          this.memberList = []
        })
    },
    getMembers() {
      return new Promise((resolve, reject) => {
        let query = `iam/${this.$route.params.id}/people?position=id|desc`

        ApiService.get(query)
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    customMemberListLabel({ cn, mail }) {
      return `${cn ? cn : ''} ${mail ? ' - ' + mail : ''}`
    },
    getList() {
      this.loading = true

      const { current_page } = this.meta
      let $query = `iam/${this.$route.params.id}/groups?position=id|desc&page=${
        current_page ? current_page : 1
      }`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    openDeleteHandler(item) {
      this.deleteOperationUrl = `iam/${this.$route.params.id}/groups/${item.dn}`
      this.$bvModal.show('modal-deleteOperation')
    },
    openForUpdate(item) {
      this.selectedItem = item
      this.showDetail = true
    },
    confirmModal() {
      this.closeSecondModal = true
      setTimeout(() => {
        this.closeSecondModal = false
      }, 200)
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      this.closeSecondModal = true
      setTimeout(() => {
        this.closeSecondModal = false
      }, 200)
      if (closeDetail) {
        this.closeDetail()
        this.getList()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
    closeDetail() {
      this.showDetail = false
    },
    openSubRowDetail(item) {
      this.openNewItem = false
      this.selectedItemId = item.dn
    },
    closeSubRowDetail() {
      this.openNewItem = false
      this.selectedItemId = ''
    },
    addNewMemberItem(itemId) {
      this.openNewItem = true
      // let objIndex = this.data.findIndex((obj) => obj.dn == itemId)
      // this.data[objIndex].member.push('')
    },
    removeMember(groupId, memberId) {
      ApiService.delete(
        `iam/${this.$route.params.id}/groups/${groupId}/member/${memberId}`
      )
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.getList()
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
        })
    },
    addMember(item) {
      ApiService.post(
        `iam/${this.$route.params.id}/groups/${item.dn}/member/${item.newMember.dn}`
      )
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.getList()
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
        })
    },
    saveDetail(item) {
      if (item.description_update) {
        let params = {
          description: item.description_update,
        }

        ApiService.put(`iam/${this.$route.params.id}/groups/${item.dn}`, params)
          .then(({ data }) => {
            item.description = item.description_update
            this.$generateToast(this, 'success', this.$t('global.successful'))
          })
          .catch((err) => {
            this.$generateToast(this, 'danger', err.message, true)
          })
      }
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
    detailData(newVal) {
      if (newVal) {
        this.setCustomHeaderParams()
      }
    },
  },
  components: {
    GroupForm: () => import('@/components/forms/iam/GroupForm'),
  },
}
</script>
